export default __webpack_public_path__ + "static/media/home-image-button-children-ministry.8038f40a.jpg";